import { Stack, Box } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-router';
import { REACT_APP_SECTION_CRS } from 'src/config';
import usePatientsOrgValidation from 'src/careflow/ph-core/multi-tenant/tenant/hook/usePatientsOrgValidation';
import PatientCard from './PatientCard';
import PatientCardSearch from 'src/careflow/common/PatientCardSearch';
import usePatientTabsStore from 'src/stores/patient-tabs';
import { getCuteScrollProps } from 'src/utils/cssStyles';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { CCM_ACLS, checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { validate as isUUID } from 'uuid';

export default function PatientTabs() {
  const { openPatientIds } = usePatientTabsStore();
  const location = useLocation();
  const pathUser = location.pathname?.slice(location.pathname?.lastIndexOf('/') + 1, location.pathname?.length);
  const path = isUUID(pathUser) ? ':patientId' : ':patientId/:currentTab';
  const urlMatch = useMatch(`/dashboard/crs/patient/${path}`);

  const setCurrentPatient = usePatientTabsStore((s) => s.setCurrentPatient);
  const openPatient = usePatientTabsStore((s) => s.openPatient);
  const isOpen = usePatientTabsStore((s) =>
    s.openPatientIds.includes(urlMatch?.params.patientId || '')
  );

  const { isLoading, patientsOrgsValid } = usePatientsOrgValidation(openPatientIds);

  useEffect(() => {
    if (!urlMatch || !urlMatch.params.patientId) {
      return;
    }

    if (!isOpen && isUUID(urlMatch.params.patientId ?? '')) {
      openPatient(urlMatch.params.patientId);
    } else {
      setCurrentPatient(urlMatch.params.patientId);
    }
  }, [location, urlMatch, setCurrentPatient, openPatient, isOpen]);

  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'scroll',
        display: 'flex',
        flexDirection: 'row',
        ...getCuteScrollProps(),
      }}
    >
      <>
        {REACT_APP_SECTION_CRS.toLowerCase() !== 'crs' ? (
          <>
            {checkAclValidation({ acls: [CCM_ACLS.PATIENT_CARD.read] }) && (
              <Stack direction="row" gap={1}>
                {openPatientIds.map((id) => (
                  <PatientCard key={id} id={id} />
                ))}
              </Stack>
            )}
          </>
        ) : (
          <>
            {checkAclValidation({
              acls: [crsAcls.CRS.PATIENT.VIEW],
            }) && (
              <Stack direction="row" gap={1}>
                {openPatientIds.map((id) => (
                  <PatientCardSearch 
                    key={id} 
                    id={id} 
                    patientsOrgsValid={patientsOrgsValid} 
                    isLoading={isLoading}
                  />
                ))}
              </Stack>
            )}
          </>
        )}
      </>
    </Box>
  );
}
